import { useState } from 'react';
import { Icon } from '@getpay93/ui';
import { useCoaches } from '../../data/hooks';
import { useAuth } from '../../auth/AuthContext';

export function OrgSwitcherClient() {
  const coaches = useCoaches();
  const { session, switchOrg } = useAuth();
  const [open, setOpen] = useState(false);
  const list = coaches.data ?? [];
  if (list.length <= 1) return <span style={{ fontWeight: 700, color: 'var(--text-strong)' }}>{session?.org?.name ?? ''}</span>;

  return (
    <div style={{ position: 'relative' }}>
      <button onClick={() => setOpen((v) => !v)} style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--text-strong)', fontWeight: 700, fontFamily: 'var(--font-sans)', fontSize: 15 }}>
        {session?.org?.name ?? 'Negocio'} <Icon name="chevron-down" size={16} />
      </button>
      {open ? (
        <div style={{ position: 'absolute', left: 0, top: '120%', minWidth: 200, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, boxShadow: 'var(--shadow-raised)', padding: 6, zIndex: 20 }}>
          {list.map((c) => (
            <button key={c.orgId} onClick={async () => { setOpen(false); if (c.orgId !== session?.org?.id) await switchOrg(c.orgId); }} style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px', borderRadius: 8, border: 'none', background: c.orgId === session?.org?.id ? 'var(--brand-green-soft)' : 'transparent', color: 'var(--text-body)', cursor: 'pointer', fontFamily: 'var(--font-sans)' }}>{c.orgName}</button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
